import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import ProductFilterView from './ProductFilterView';
import ProductDetailVew from './ProductDetailView';

class ProductListView extends Component {

  constructor(props) {
    super(props);
    this.handleEnterProduct = this.handleEnterProduct.bind(this);
    this.handleLeaveProduct = this.handleLeaveProduct.bind(this);
    this.addToCard = this.addToCard.bind(this);
    this.state = {
      displayActions: {},
    };
  }

  handleEnterProduct(event, obj) {
    this.setState({
      displayActions: obj,
    });
  }

  handleLeaveProduct() {
    this.setState({
      displayActions: {},
    });
  }

  addToCard(data) {
    this.props.addToCard(data);
  }

  isSelected(product, type) {
    const {displayActions: currentSelected} = this.state;
    return currentSelected.id === product.id && currentSelected.type === type;
  }

  render() {
    const {
      products, filterType, categories, pizzaCategories, selectCategory, filterCategory, language, currentRestaurant,
    } = this.props;
    const categoryList = filterType === 'pizza' ? pizzaCategories : categories;
    return (
      <div className="products__list">
        {!!categoryList.size && (
          <ProductFilterView
            categories={categoryList}
            selectCategory={selectCategory}
            filterCategory={filterCategory}
            language={language}
          />
        )}
        <div className="products__items">
          {products.valueSeq().map(product => (
            <ProductDetailVew
              type={filterType}
              language={language}
              key={product.id}
              isSelected={this.isSelected(product, filterType)}
              product={product}
              onMouseLeave={this.handleLeaveProduct}
              onMouseEnter={this.handleEnterProduct}
              addToCard={this.addToCard}
              customize={{path: `/${currentRestaurant.name_for_url}/products/pizza/customize/${product.id}`}}
              canIncrease={filterType !== 'deals'}
              showPrice={true}
              restaurant={currentRestaurant}
              isPartOfComposition={false}
            />
          ))}
        </div>
      </div>
    );
  }
}

ProductListView.propTypes = {
  products: PropTypes.object,
  filterType: PropTypes.string,
  addToCard: PropTypes.func,
  selectCategory: PropTypes.func,
  basket: PropTypes.object,
  language: PropTypes.string,
  categories: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  pizzaCategories: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  ingredients: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  filterCategory: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default translate('translations')(ProductListView);


// WEBPACK FOOTER //
// ./src/components/Product/ProductListView.js